(() => {
  if (window.__nuvialleFlavourPicker) return;
  window.__nuvialleFlavourPicker = true;

  const formatMoney = (cents, format) => {
    const value = (Number(cents) || 0) / 100;
    const withDelim = (n, dec, thou, sep) => {
      const [i, d] = n.toFixed(dec).split('.');
      return i.replace(/\B(?=(\d{3})+(?!\d))/g, thou) + (d ? sep + d : '');
    };
    const fmt = format || '${{amount}}';
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount_no_decimals': return withDelim(value, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelim(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelim(value, 0, '.', ',');
        default: return withDelim(value, 2, ',', '.');
      }
    });
  };

  const init = (root) => {
    if (!root || root.dataset.nvReady) return;
    root.dataset.nvReady = '1';

    const bundleSize = Number(root.dataset.bundleSize) || 3;
    const bundlePrice = Number(root.dataset.bundlePrice) || 0;
    const maxPicks = Number(root.dataset.maxPicks) || 12;
    const moneyFormat = root.dataset.moneyFormat;
    const money = (c) => formatMoney(c, moneyFormat);

    const tiles = [...root.querySelectorAll('[data-nv-fp-tile]')];
    const byId = new Map(tiles.map((t) => [t.dataset.variantId, t]));
    const qty = new Map(); // variantId -> count, in pick order
    const order = [];

    const $ = (s) => root.querySelector(s);
    const picksEl = $('[data-nv-fp-picks]');
    const totalEl = $('[data-nv-fp-total]');
    const fullEl = $('[data-nv-fp-full]');
    const saveEl = $('[data-nv-fp-save]');
    const nudgeEl = $('[data-nv-fp-nudge]');
    const cta = $('[data-nv-fp-cta]');
    const ctaEmpty = cta.textContent;
    const toast = $('.nv-fp__toast');
    const toastText = $('[data-nv-fp-toast]');
    const track = $('[data-nv-fp-track]');
    let toastTimer;

    const showToast = (msg) => {
      toastText.textContent = msg;
      toast.classList.add('is-visible');
      clearTimeout(toastTimer);
      toastTimer = setTimeout(() => toast.classList.remove('is-visible'), 2400);
    };

    /* ---------- Gallery ---------- */
    const slides = [...root.querySelectorAll('.nv-fp__slide')];
    const goToSlide = (index) => {
      if (!track || !slides.length) return;
      const i = Math.max(0, Math.min(slides.length - 1, index));
      track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
    };
    const currentSlide = () => (track ? Math.round(track.scrollLeft / Math.max(1, track.clientWidth)) : 0);
    $('[data-nv-fp-prev]')?.addEventListener('click', () => goToSlide(currentSlide() - 1));
    $('[data-nv-fp-next]')?.addEventListener('click', () => goToSlide(currentSlide() + 1));
    const showMediaFor = (tile) => {
      const id = tile.dataset.mediaId;
      if (!id) return;
      const index = slides.findIndex((s) => s.dataset.mediaId === id);
      if (index >= 0) goToSlide(index);
    };

    /* ---------- Picks + pricing ---------- */
    const count = () => [...qty.values()].reduce((a, b) => a + b, 0);
    const unitPrice = (id) => Number(byId.get(id)?.dataset.price) || 0;
    const fullTotal = () => [...qty.entries()].reduce((sum, [id, n]) => sum + unitPrice(id) * n, 0);
    // Mirrors the automatic discount: at bundle size or more, every unit costs bundlePrice / bundleSize.
    const payTotal = () => {
      const n = count();
      if (!bundlePrice || n < bundleSize) return fullTotal();
      return Math.round((bundlePrice / bundleSize) * n);
    };

    const render = () => {
      const n = count();
      tiles.forEach((tile) => {
        const q = qty.get(tile.dataset.variantId) || 0;
        tile.classList.toggle('is-selected', q > 0);
        tile.setAttribute('aria-pressed', q > 0 ? 'true' : 'false');
        const qEl = tile.querySelector('[data-nv-fp-qty]');
        if (qEl) qEl.textContent = q;
      });

      picksEl.innerHTML = '';
      order.forEach((id) => {
        const tile = byId.get(id);
        const swatch = tile.querySelector('.nv-fp__swatch');
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'nv-fp__pick';
        btn.setAttribute('aria-label', `Remove ${tile.dataset.name}`);
        btn.dataset.variantId = id;
        btn.appendChild(swatch.cloneNode(true));
        btn.insertAdjacentHTML('beforeend', '<span class="nv-fp__pick-remove" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M6 6l12 12M18 6 6 18"/></svg></span>');
        picksEl.appendChild(btn);
      });
      for (let i = n; i < bundleSize; i++) {
        const slot = document.createElement('span');
        slot.className = 'nv-fp__pick-placeholder';
        slot.textContent = String(i + 1);
        picksEl.appendChild(slot);
      }

      const full = fullTotal();
      const pay = payTotal();
      totalEl.textContent = money(pay);
      const saving = full - pay;
      fullEl.hidden = saving <= 0;
      saveEl.hidden = saving <= 0;
      if (saving > 0) {
        fullEl.textContent = money(full);
        saveEl.textContent = `Save ${money(saving)}`;
      }

      if (nudgeEl && bundlePrice) {
        if (n === 0) nudgeEl.innerHTML = `Mix &amp; match &mdash; any ${bundleSize} for <strong>${money(bundlePrice)}</strong>`;
        else if (n < bundleSize) nudgeEl.innerHTML = `Add <strong>${bundleSize - n} more</strong> to get ${bundleSize} for <strong>${money(bundlePrice)}</strong>`;
        else nudgeEl.innerHTML = `Deal unlocked &mdash; <strong>${money(bundlePrice / bundleSize)}</strong> each`;
      }

      cta.disabled = n === 0;
      cta.textContent = n === 0 ? ctaEmpty : `Add ${n} to bag — ${money(pay)}`;
    };

    const add = (id) => {
      const tile = byId.get(id);
      if (!tile || tile.hasAttribute('data-unavailable')) return;
      if (count() >= maxPicks) return showToast(`You can add up to ${maxPicks} at a time`);
      qty.set(id, (qty.get(id) || 0) + 1);
      order.push(id);
      render();
    };
    const remove = (id) => {
      const q = qty.get(id) || 0;
      if (!q) return;
      if (q === 1) qty.delete(id);
      else qty.set(id, q - 1);
      const idx = order.lastIndexOf(id);
      if (idx >= 0) order.splice(idx, 1);
      render();
    };

    tiles.forEach((tile) => {
      const id = tile.dataset.variantId;
      tile.addEventListener('click', (e) => {
        if (e.target.closest('[data-nv-fp-plus]')) { e.stopPropagation(); return add(id); }
        if (e.target.closest('[data-nv-fp-minus]')) { e.stopPropagation(); return remove(id); }
        if (tile.hasAttribute('data-unavailable')) return showToast(`${tile.dataset.name} is sold out`);
        showMediaFor(tile);
        document.dispatchEvent(new CustomEvent('nuvialle:flavour-selected', { detail: { variantId: id, title: tile.dataset.name } }));
        if (!qty.get(id)) add(id);
      });
      tile.addEventListener('keydown', (e) => {
        if (e.target !== tile || (e.key !== 'Enter' && e.key !== ' ')) return;
        e.preventDefault();
        tile.click();
      });
    });
    picksEl.addEventListener('click', (e) => {
      const pick = e.target.closest('.nv-fp__pick');
      if (pick) remove(pick.dataset.variantId);
    });

    /* ---------- Search + filters ---------- */
    const search = $('[data-nv-fp-search]');
    const chips = [...root.querySelectorAll('[data-nv-fp-chip]')];
    const countEl = $('[data-nv-fp-count]');
    const clearBtn = $('[data-nv-fp-clear]');
    const emptyEl = $('[data-nv-fp-empty]');
    let activeChip = 'All';

    const applyFilter = () => {
      const q = (search.value || '').trim().toLowerCase();
      let shown = 0;
      tiles.forEach((tile) => {
        const cats = (tile.dataset.categories || '').split(',').map((c) => c.trim());
        const okChip = activeChip === 'All' || cats.includes(activeChip);
        const okText = !q || tile.dataset.name.toLowerCase().includes(q);
        tile.hidden = !(okChip && okText);
        if (!tile.hidden) shown++;
      });
      countEl.textContent = `${shown} flavour${shown === 1 ? '' : 's'}`;
      clearBtn.hidden = !(q || activeChip !== 'All');
      emptyEl.hidden = shown > 0;
    };
    search.addEventListener('input', applyFilter);
    chips.forEach((chip) =>
      chip.addEventListener('click', () => {
        activeChip = chip.dataset.nvFpChip;
        chips.forEach((c) => c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'));
        applyFilter();
      })
    );
    clearBtn.addEventListener('click', () => {
      search.value = '';
      activeChip = 'All';
      chips.forEach((c) => c.setAttribute('aria-pressed', c.dataset.nvFpChip === 'All' ? 'true' : 'false'));
      applyFilter();
    });

    /* ---------- Add to bag ---------- */
    cta.addEventListener('click', async () => {
      const n = count();
      if (!n) return;
      cta.disabled = true;
      const cartDrawer = document.querySelector('cart-drawer');
      const payload = {
        items: [...qty.entries()].map(([id, quantity]) => ({ id: Number(id), quantity })),
        sections: ['cart-icon-bubble'].concat(cartDrawer ? ['cart-drawer'] : []).join(','),
        sections_url: window.location.pathname,
      };
      try {
        const addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
        const res = await fetch(`${addUrl}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload),
        });
        const data = await res.json();
        if (!res.ok || data.status) throw new Error(data.description || 'Could not add to bag');
        qty.clear();
        order.length = 0;
        render();
        if (cartDrawer && typeof cartDrawer.renderContents === 'function' && data.sections) {
          cartDrawer.renderContents(data);
          document.dispatchEvent(new CustomEvent('nuvialle:item-added', { detail: data }));
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
      } catch (err) {
        showToast(err.message || 'Could not add to bag');
        cta.disabled = false;
      }
    });

    render();
    applyFilter();
  };

  const boot = () => document.querySelectorAll('[data-nv-fp]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', (e) => init(e.target.querySelector('[data-nv-fp]')));
})();
